/**
 * API Configuration
 * Central configuration for API endpoints and settings
 */

const rawBaseUrl = process.env.REACT_APP_API_BASE_URL;

const API_CONFIG = {
  // Empty string = same-origin (CRA setupProxy). Host only otherwise —
  // apiService paths already include `/api/v1/...`
  BASE_URL:
    rawBaseUrl === '' || rawBaseUrl === '/'
      ? ''
      : (rawBaseUrl || 'http://localhost:3001').replace(/\/api\/?$/, ''),

  // Request timeout in milliseconds (30 seconds)
  TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT, 10) || 30000,

  // Default headers
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },

  // Token configuration
  TOKEN: {
    STORAGE_KEY: 'authToken',
    HEADER_NAME: 'Authorization',
    PREFIX: 'Bearer',
  },

  // Environment detection
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',

  // API versioning
  API_VERSION: 'v1',
};

export default API_CONFIG;
